export default {
  columnData: [],
  banner: [],
  orderList: []
}
